import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type {
  IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleRequest,
  IxmUserauthV1JoinedRealmAccess,
} from '@interxfi/types/generated/api';
import { withAuthorizationToken } from '../api-client';
import { useRealmAuthActiveAccess } from '../context';
import { ixmUserauthV1ArtifactDownloadServiceDownloadArtifactBundle } from '../generated/client-functions';
import { buildIxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleKey } from '../generated/hooks/ixm-userauth-v1-artifact-download-service-download-artifact-bundle';
import { useRealmAPIContext } from '../realm-context';

export function useDownloadProgramArtifacts(withAccess?: IxmUserauthV1JoinedRealmAccess) {
  const activeAccess = useRealmAuthActiveAccess();
  const { baseUrl, extendKey, token } = useRealmAPIContext(withAccess ?? activeAccess);
  const queryClient = useQueryClient();

  return useCallback(
    (request: IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleRequest) =>
      queryClient.fetchQuery({
        queryKey: extendKey([...buildIxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleKey(), request]),
        queryFn: async () => {
          const result = await ixmUserauthV1ArtifactDownloadServiceDownloadArtifactBundle(baseUrl, request, withAuthorizationToken(token));
          if (!result) {
            return undefined;
          }

          return {
            ...result,
            artifacts: result.artifacts?.map((artifact) => ({
              ...artifact,
              file: window.atob(artifact.file),
            })),
          };
        },
      }),
    [baseUrl, extendKey, token, queryClient],
  );
}
